import React, { CSSProperties, ReactNode } from "react";
import styled from "styled-components";
import Text from "common/Typography/Text.tsx";

interface RowLabelProps {
  icon?: ReactNode;
  children: ReactNode;
  textStyle?: CSSProperties;
}

/** A row's label, with the new look's leading icon when one is given. */
const RowLabel = ({ icon, children, textStyle }: RowLabelProps) => {
  if (!icon) return <Text style={textStyle}>{children}</Text>;
  return (
    <Wrapper>
      <IconSlot>{icon}</IconSlot>
      <Text style={textStyle}>{children}</Text>
    </Wrapper>
  );
};

export default RowLabel;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;
const IconSlot = styled.span`
  display: inline-flex;
  flex: none;
  color: ${(p) => p.theme.colors.secondaryText};
`;
